import { render } from "./workflowphase-item.vue?vue&type=template&id=a23971ca"
import script from "./workflowphase-item.vue?vue&type=script&lang=js"
export * from "./workflowphase-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__